import { Unicode } from '@tcs/common/utils/unicode';
import cs from 'classnames';
import { useStyles } from '../style';

interface CellProps {
  value: string | number;
  className?: string;
  align?: 'left' | 'right';
  isPrivate?: boolean;
  error?: boolean;
}

const BaseCell = ({
  value,
  className,
  align = 'left',
  isPrivate = false,
  error = false,
}: CellProps) => {
  const classes = useStyles({});
  const formattedValue = value ?? Unicode.EmDash;

  return (
    <div
      className={cs(
        classes.baseCell,
        {
          [classes.rightAlign]: align === 'right',
          [classes.error]: error === true,
        },
        className
      )}
      title={`${formattedValue}`}
      data-private={isPrivate || null}>
      {formattedValue}
    </div>
  );
};

export default BaseCell;
